import { render, staticRenderFns } from "./lms-surfana.vue?vue&type=template&id=342ef7d3&"
import script from "./lms-surfana.vue?vue&type=script&lang=js&"
export * from "./lms-surfana.vue?vue&type=script&lang=js&"
import style0 from "./lms-surfana.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports